export const TKeyHome = {
  HOME_POWERED_BY_LABEL: "HOME_POWERED_BY_LABEL",
  HOME_TESTIMONIALS_SUP_TITLE: "HOME_TESTIMONIALS_SUP_TITLE",
  HOME_TESTIMONIALS_TITLE: "HOME_TESTIMONIALS_TITLE",
  HOME_TESTIMONIALS_TITLE_2: "HOME_TESTIMONIALS_TITLE_2",
  HOME_WHO_1_TITLE: "HOME_WHO_1_TITLE",
  HOME_WHO_1_TEXT: "HOME_WHO_1_TEXT",
  HOME_WHO_1_ANSWER: "HOME_WHO_1_ANSWER",
  HOME_WHO_3_TITLE: "HOME_WHO_3_TITLE",
  HOME_WHO_3_TEXT: "HOME_WHO_3_TEXT",
  HOME_WHO_3_ANSWER: "HOME_WHO_3_ANSWER",
  HOME_TESTIMONIAL_1_QUOTE: "HOME_TESTIMONIAL_1_QUOTE",
  HOME_TESTIMONIAL_1_ROLE: "HOME_TESTIMONIAL_1_ROLE",
  HOME_TESTIMONIAL_2_QUOTE: "HOME_TESTIMONIAL_2_QUOTE",
  HOME_TESTIMONIAL_2_ROLE: "HOME_TESTIMONIAL_2_ROLE",
  HOME_TESTIMONIAL_3_QUOTE: "HOME_TESTIMONIAL_3_QUOTE",
  HOME_TESTIMONIAL_3_ROLE: "HOME_TESTIMONIAL_3_ROLE",
  HOME_TESTIMONIAL_4_QUOTE: "HOME_TESTIMONIAL_4_QUOTE",
  HOME_TESTIMONIAL_4_ROLE: "HOME_TESTIMONIAL_4_ROLE",
  HOME_TESTIMONIAL_5_QUOTE: "HOME_TESTIMONIAL_5_QUOTE",
  HOME_TESTIMONIAL_5_ROLE: "HOME_TESTIMONIAL_5_ROLE",
  HOME_TESTIMONIAL_6_QUOTE: "HOME_TESTIMONIAL_6_QUOTE",
  HOME_TESTIMONIAL_6_ROLE: "HOME_TESTIMONIAL_6_ROLE",
  HOME_TESTIMONIAL_7_QUOTE: "HOME_TESTIMONIAL_7_QUOTE",
  HOME_TESTIMONIAL_7_ROLE: "HOME_TESTIMONIAL_7_ROLE",
  HOME_TESTIMONIAL_8_QUOTE: "HOME_TESTIMONIAL_8_QUOTE",
  HOME_TESTIMONIAL_8_ROLE: "HOME_TESTIMONIAL_8_ROLE",
  HOME_STAT_1_LABEL: "HOME_STAT_1_LABEL",
  HOME_STAT_2_LABEL: "HOME_STAT_2_LABEL",
  HOME_STAT_3_LABEL: "HOME_STAT_3_LABEL",
  HOME_STAT_4_LABEL: "HOME_STAT_4_LABEL",
} as const;
